import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { useQuery, useMutation } from 'react-query';
import { TRINHDO_API } from '@app/utils/apiUrl.js';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tenTrinhDo: yup.string().required('Tên trình độ không được để trống'),
    tenVanBangChungChi: yup.string().required('Tên văn bằng chứng chỉ không được để trống'),
    documentLink: yup.string()
});

const TrinhDoEdit = () => {
    const history = useHistory();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    const itemEdit = useQuery([itemId], () => Get(TRINHDO_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });
    const editFunc = useMutation((value) => Put(TRINHDO_API.UPDATE_ITEM, itemId, value));

    const handleEdit = async (values) => {
        editFunc.mutate(values, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastUpdateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    if (itemEdit.isLoading) {
        return <div>Đang tải...</div>;
    }

    if (itemEdit.isError) {
        return <div>Có lỗi xảy ra: {itemEdit.error?.message}</div>;
    }

    if (!itemEdit.data) {
        return <div>Không tìm thấy trình độ.</div>;
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa trình độ</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        tenTrinhDo: itemEdit.data.tenTrinhDo || itemEdit.data.TenTrinhDo || '',
                        tenVanBangChungChi:
                            itemEdit.data.tenVanBangChungChi ||
                            itemEdit.data.TenVanBangChungChi ||
                            '',
                        documentLink: itemEdit.data.documentLink || itemEdit.data.DocumentLink || ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên trình độ
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên trình độ"
                                        type="text"
                                        name="tenTrinhDo"
                                        value={values.tenTrinhDo}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenTrinhDo}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenTrinhDo}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên văn bằng chứng chỉ
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên văn bằng chứng chỉ"
                                        type="text"
                                        name="tenVanBangChungChi"
                                        value={values.tenVanBangChungChi}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenVanBangChungChi}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenVanBangChungChi}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Đường dẫn tài liệu
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập đường dẫn tài liệu"
                                        type="text"
                                        name="documentLink"
                                        value={values.documentLink}
                                        onChange={handleChange}
                                        isInvalid={!!errors.documentLink}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.documentLink}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={editFunc.isLoading}>
                                            Lưu
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default TrinhDoEdit;
